import { Group, Student } from '@monorepo/shared/src/graph/schema-generated-types-educator';

export const isInGroup = (groups: Group[]) => (student: Student) =>
  groups.some((group) =>
    group.groupEnrollments.some((groupEnrollment) => groupEnrollment?.studentId === student.id)
  );
